<template>
	<div class="main">
		<header class="page-title">
			<h2>Categories</h2>
			<div class="ml-auto">
				<a href="#" @click="showModal" class="btn btn-md btn-success" v-if="userRoles.includes('categories.update')"><i class="fas fa-plus"></i> New Category</a>
			</div>
		</header>
		<div class="table-responsive">
			<table>
				<thead>
					<tr>
						<th>Name</th>
						<th>Slug</th>
						<th>Posts</th>
						<th class="actions">Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="category in categoriesList">
						<td>{{ category.title }}</td>
						<td>{{ category.slug }}</td>
						<td>{{ category.postCounter }}</td>
						<td>
							<a class="btn btn-icon btn-primary" title="Edit" :href="'/' + selectedSite.slug + '/categories/' + category.id + '/edit'" v-if="userRoles.includes('categories.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
							<a href="#" class="btn btn-icon btn-danger" title="Delete" @click.prevent="deleteCategory(category.id)" v-if="userRoles.includes('categories.delete')"><i class="fas fa-fw fa-trash"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<modal :modal-name="'newCategory'">
			<template #modal-header>
				<h4 class="modal-title">New Category</h4>
			</template>
			<template #modal-body>
				<div class="form-group">
					<label for="title">Title</label>
					<input id="title" type="text" v-model="category.en.title">
					<p class="input-error" v-if="errors.errors['en_title']">{{ errors.errors['en_title'] }}</p>
				</div>
				<div class="form-group">
					<label for="slug">URL Slug (plural)</label>
					<input id="slug" type="text" v-model="category.en.slug">
					<p class="input-error" v-if="errors.errors['en_slug']">{{ errors.errors['en_slug'] }}</p>
				</div>
				<div class="form-group">
					<label class="label-checkbox">
						<input type="checkbox" v-model="category.is_hidden">
						<span>Hidden Category</span>
					</label>
				</div>
			</template>
			<template #modal-footer>
				<a @click="createCategory" class="btn btn-md btn-success" href="#"><i class="fas fa-plus"></i> Add Category</a>
			</template>
		</modal>
	</div>
</template>

<script>
import Errors from '../../Utils/Errors.js';
import Modal from "../Modal/Modal";
import {eventBus} from "../../app";

export default {
	components: {
		Modal
	},
	props: {
		dataCategoriesList: {
			type: Array
		},
	},
	data() {
		return {
			categoriesList: this.dataCategoriesList,
			userRoles: this.$currentUserRoles,
			selectedSite: this.$selectedSite,

			category: {
				en: {
					title: null,
					slug: null
				},
				hidden: false
			},

			errors: new Errors()
		}
	},
	methods: {
		showModal: function () {
			eventBus.$emit('onModalOpen_newCategory');
		},
		closeModal: function () {
			eventBus.$emit('onModalClose_newCategory');
			this.category = {
				en: {
					title: null,
					slug: null
				},
				hidden: false
			};
		},
		createCategory: function () {
			let vm = this;
			axios.post('/api/' + vm.$selectedSite.slug + '/categories', vm.category)
					.then(response => {
						if (response.data.success) {
							this.$toastr.success('New category saved.');
							vm.closeModal();
							setTimeout(function () {
								window.location.reload();
							}, 1000);
						} else {
							vm.errors.record(response.data);
							this.$toastr.error('Save new category failed.', 'Error');
						}
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Save new provider type failed.', 'Error');
					});
		},
		deleteCategory: function (id) {
			let vm = this;
			vm.$dialog.confirm('Are you sure you want to delete this category?')
					.then((dialog) => {
						axios.delete('/api/' + vm.selectedSite.slug + '/categories/' + id)
								.then(response => {
									vm.$toastr.success('Category deleted.');
									window.location.reload();
								})
								.catch(e => {
									vm.$toastr.error('Delete category failed.', 'Error');
								})
					})
					.catch(error => {
						vm.$toastr.error('Delete aborted.');
					});
		}
	}
}
</script>
